import React, { useEffect } from 'react';
import { CssBaseline as MuiCssBaseline } from '@mui/material';
import { ThemeProvider as MuiThemeProvider, useColorScheme } from '@mui/material/styles';
import GoogleAnalytics from '~/components/google/GoogleAnalytics';
import Notifications from '~/components/Notifications';
import SpinnerTw from '~/components/SpinnerTw';
import TooltipContainer from '~/components/TooltipContainer';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { CommonAppContext, useCommonAppContext, useInitCommonAppState } from '~/shared/contexts/CommonAppContext';
import StandardLayout from '~/shared/layouts/StandardLayout';
import { theme } from '~/sites/benlieb/mui/themes';
import { getLcn } from '~/utils/labeled-classnames';
import Banner from './layout/Banner';
import { Branding } from './layout/Branding';
import SidebarContent from './layout/SidebarContent';
import { BenliebAppContext, useBenliebAppContext, useInitAppContextState } from '../contexts/app/BenliebAppContext';

export const appConstants = {
}

export const layoutConstants = {
  bannerHeight: 70,
}

function Providers({ children }: { children: React.ReactNode }) {
  const commonAppState = useInitCommonAppState()

  const appState = useInitAppContextState();

  return (
    <HelmetProvider>
      <GoogleAnalytics propertyId="G-XXX" />
      <CommonAppContext.Provider value={commonAppState}>
        <BenliebAppContext.Provider value={appState}>
          <MuiThemeProvider theme={theme} defaultMode='light'>
            {/* CssBaseline includes global CSS resets and may conflict with TW it also is responsible for light/dark mode defaults, hrm */}
            <MuiCssBaseline />

            {children}
          </MuiThemeProvider>
        </BenliebAppContext.Provider>
      </CommonAppContext.Provider>
    </HelmetProvider>
  )
}

export default function BenliebAppBase() {
  const { mode, setMode } = useColorScheme();
  const { pageUsesSidebar } = useBenliebAppContext()
  const { isLoadingSessionUser } = useCommonAppContext()

  // always dark for now
  useEffect(() => {
    setMode('dark');
  }, [setMode]);

  if (isLoadingSessionUser) {
    return <SpinnerTw center={true} />;
  }
  const lcn = getLcn({
    benliebApp: '',
  });

  const mainContentStyle = {
    minHeight: `calc(100vh - 100px)`,
  }

  return (
    <Providers>
      <Helmet>
        <title>Benjamin Moses Lieb - Home on the Web</title>
        <meta name="description" content="Benlieb description" />
      </Helmet>

      <div className={lcn.benliebApp}>

        <div style={mainContentStyle}>
          <StandardLayout
            banner={<Banner />}
            sideBarContent={<SidebarContent />}
            sidebarBanner={<Branding />}
            pageUsesSidebar={pageUsesSidebar}
            alwaysFloatSidebar={true}
          />
        </div>

        <Notifications />
        <TooltipContainer />
      </div>
    </Providers>
  );
}